/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Family } from "../types/Family";
export const Response = core.serialization.list(Family);
